import React, { useState, useEffect, useCallback } from 'react';
import Button from '../../component/button/button';
import type { TeacherProps } from './TeacherInterface';
import '../Modal/Modal.scss';
import Select from 'react-select';
import { SubjectProps } from '../Subjects/SubjectInterface';
import { listSubject } from '../../api/subject';
import {
  assignSubjectToTeacher,
  getAssignedSubject,
  removeAllAssignedSubject,
  removeAssignedSubject,
} from '../../api/teacher';
import { LoaderComponent } from '../../utils/Helper';
import toast from 'react-hot-toast';
import { FiCheckCircle } from 'react-icons/fi';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  teacher?: TeacherProps;
}

const customStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  placeholder: (base: any) => ({
    ...base,
    color: 'var(--gray-900)',
    fontFamily: 'Plus Jakarta Sans',
    fontSize: ' 14px',
    fontWeight: '400',
  }),
  singleValue: (base: any) => ({
    ...base,
    color: 'var(--gray-900)',
    fontFamily: 'Plus Jakarta Sans',
    fontSize: ' 14px',
    fontWeight: '400',
  }),
  multiValue: (base: any) => ({
    ...base,
    color: 'var(--gray-900)',
    fontFamily: 'Plus Jakarta Sans',
    fontSize: ' 14px',
    fontWeight: '400',
  }),
};

export const AssignSubject: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  teacher,
}) => {
  const [assignedSubject, setAssignedSubject] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [subjects, setSubjects] = useState<SubjectProps[]>([]);

  const fetchSubjectData = useCallback(async () => {
    try {
      const response = await listSubject(1, '', 'all');
      const subjects = response?.data?.data?.subjects || [];
      setSubjects(subjects);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (teacher?.id) {
        try {
          setLoading(true);

          const [_, assignedSubjectResponse] = await Promise.all([
            fetchSubjectData(),
            getAssignedSubject(teacher.id),
          ]);

          // Set assigned subjects data
          const assignedSubjects = assignedSubjectResponse?.data?.data.map(
            (item: any) => ({
              value: item?.id,
              label: item?.title,
            })
          );
          setAssignedSubject(assignedSubjects);
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [teacher?.id]);

  const multiselectChangeHandler = (selectedOptions: any) => {
    const removedSubjects: {
      label: string;
      value: string;
    }[] = assignedSubject.filter(
      (item: any) =>
        !selectedOptions.some((selected: any) => selected.value === item.value)
    );

    if (
      removedSubjects &&
      removedSubjects.length &&
      removedSubjects.length > 0
    ) {
      if (
        !selectedOptions ||
        (selectedOptions.length === 0 && assignedSubject.length)
      ) {
        handleRemoveAllSubject();
        return;
      }
      handleRemoveSubject(removedSubjects[0].value);
    }
    setAssignedSubject(selectedOptions);
  };

  const handleRemoveAllSubject = () => {
    if (!teacher?.id) return;
    setRemoving(true);
    removeAllAssignedSubject(
      teacher?.id,
      assignedSubject.map((item: any) => item.value)
    )
      .then(res => {
        const message = `All Subjects has been removedsuccessfully.`;
        setAssignedSubject([]);
        notify(message);
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setRemoving(false);
      });
  };
  const handleRemoveSubject = (subjectId: string) => {
    setRemoving(true);
    if (!teacher?.id || !subjectId) return;
    removeAssignedSubject(teacher?.id, subjectId)
      .then(res => {
        const message = `Subject has been removed successfully.`;
        notify(message);
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setRemoving(false);
      });
  };

  const handleAssignSubject = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!teacher?.id) return;

    if (!assignedSubject.length) {
      {
        onClose();
        return;
      }
    }

    setSubmitting(true);
    const subjectIds = assignedSubject.map(
      (subject: { value: string }) => subject.value
    );

    assignSubjectToTeacher(teacher?.id, subjectIds)
      .then(res => {
        const message = `${teacher?.first_name} has been successfully assigned a subject.`;
        notify(message);
        onClose();
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const notify = (message: string) => {
    toast.success(message, {
      icon: <FiCheckCircle color={'var(--success-600)'} size={58} />,
    });
  };

  if (!isOpen || !teacher) return null;

  return (
    <div className="modal-backdrop assing_subject_modal">
      <div
        className="modal p-3"
        style={{
          overflow: 'inherit',
        }}
      >
        <div className="modal-header">
          <h2>Assign subject(s)</h2>
        </div>
        {loading ? (
          <LoaderComponent size="sm" label="Loading subjects…" />
        ) : (
          <form onSubmit={handleAssignSubject}>
            <div
              className="modal-body"
              style={{
                overflow: 'inherit !important',
              }}
            >
              <div className="form-group ">
                <label htmlFor="teacher">Assigned to</label>
                <div className="teacher_detail" id="teacher">
                  <div className="teacher_detail_profile">
                    <img src={teacher.profile_photo} alt={teacher.first_name} />
                  </div>
                  <p>
                    {teacher.first_name} {teacher.last_name}
                  </p>
                </div>
              </div>

              <div className="form-group ">
                <label htmlFor="teacher">Subject(s)</label>
                <Select
                  styles={customStyles}
                  placeholder="Select subjects"
                  name="teachers"
                  isMulti
                  // isClearable={false}
                  options={(subjects as any).map((item: SubjectProps) => ({
                    value: item.id,
                    label: item.title,
                  }))}
                  value={assignedSubject}
                  onChange={multiselectChangeHandler}
                />
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-span-1 md:col-span-2 text-right flex justify-end gap-2">
                <Button
                  text={
                    removing
                      ? 'Removing...'
                      : submitting
                        ? 'Assigning...'
                        : 'Assign'
                  }
                  buttonType="submit"
                  disabled={submitting}
                  style={{
                    height: 45,
                    fontSize: 14,
                  }}
                />
                <Button
                  text="Close"
                  buttonType="button"
                  type="secondary"
                  onClick={onClose}
                  disabled={submitting}
                  style={{
                    height: 45,
                    fontSize: 14,
                  }}
                />
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
